import { ReactNode } from "react";
import ReactFilestack from "filestack-react";
import { FILESTACK_KEY } from "../env";

const basicOptions = {
  maxSize: 10 * 1024 * 1024, // 10MiB
  maxFiles: 1,
};

export type FilePickerTrigger = (props: { show: () => void }) => ReactNode;
type Value = { url: string; mimetype: string };

function FilePicker({
  trigger,
  mode = "image",
  path,
  options = {},
  onChange,
}: {
  trigger: FilePickerTrigger;
  mode?: "*" | "image" | "audio" | "video" | "imageVideo";
  path?: string;
  options?: any;
  value?: any; //this isn't used, but is here as a convenience for useFields
  onChange: (v: Value) => void;
}) {
  const handleSuccess = (results: { filesUploaded: Value[] }) => {
    if (results.filesUploaded[0]) onChange(results.filesUploaded[0]);
  };

  const handleError = (e: Error) => {
    console.error(e);
  };

  const accept = {
    "*": () => true,
    image: (mime: string) => mime.includes("image"),
    audio: (mime: string) => mime.includes("audio"),
    video: (mime: string) => mime.includes("video"),
    imageVideo: (mime: string) =>
      mime.includes("video") || mime.includes("image"),
  }[mode];

  const fromSources = {
    "*": [
      "local_file_system",
      "webcam",
      "url",
      "video",
      "audio",
      "imagesearch",
      "facebook",
      "instagram",
      "googledrive",
      "dropbox",
      "onedrive",
    ],
    image: [
      "local_file_system",
      "webcam",
      "url",
      "imagesearch",
      "facebook",
      "instagram",
      "googledrive",
      "dropbox",
      "onedrive",
    ],
    audio: [
      "local_file_system",
      "audio",
      "url",
      "facebook",
      "instagram",
      "googledrive",
      "dropbox",
      "onedrive",
    ],
    video: [
      "local_file_system",
      "webcam",
      "url",
      "video",
      "facebook",
      "instagram",
      "googledrive",
      "dropbox",
      "onedrive",
    ],
    imageVideo: [
      "local_file_system",
      "webcam",
      "url",
      "video",
      "imagesearch",
      "facebook",
      "instagram",
      "googledrive",
      "dropbox",
      "onedrive",
    ],
  }[mode];

  return (
    <ReactFilestack
      apikey={FILESTACK_KEY}
      link
      actionOptions={{
        ...basicOptions,
        accept: [
          "image/*",
          "audio/mp3",
          "audio/mpeg",
          "audio/wav",
          "video/mpeg",
          "video/mp4",
          "video/quicktime",
        ].filter(accept),
        allowManualRetry: true,
        fromSources,
        storeTo: {
          location: "s3",
          path,
          access: "public",
        },
        ...options,
      }}
      onSuccess={handleSuccess}
      onError={handleError}
      customRender={({ onPick }: { onPick: () => void }) =>
        trigger({ show: onPick })
      }
    />
  );
}

export default FilePicker;
